import { OrderedSet } from 'immutable'
export default function stubImmutableOrderedSet() {
  return OrderedSet([])
}
